query allTennisTeams(
  $first: Int,
  $offset: Int,
  $filter: TennisTeamFilter,
  ) {
  teams: allTennisTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamId
      name
      gender
      source
      shortName
      singles
      squad
        mappings: tennisTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingType
        }
      }
    }
    totalCount
  }
}
